import * as Icons from "../icons";

export const NAV_DATA = [
  {
    label: "MAIN MENU",
    items: [
      {
        title: "Dashboard",
        icon: Icons.HomeIcon,
        items: [
          {
            title: "Overview",
            url: "/",
          },
        ],
      },
      {
        title: "Bookings",
        url: "/bookings",
        icon: Icons.Calendar,
        items: [
          {
            title: "All Bookings",
            url: "/bookings",
          },
          {
            title: "Create Booking",
            url: "/bookings/create",
          },
        ],
      },
      {
        title: "Stays",
        url: "/stays",
        icon: Icons.BuildingIcon,
        items: [
          {
            title: "All Stays",
            url: "/stays",
          },
          {
            title: "Create Stay",
            url: "/stays/create",
          },
          {
            title: "Accommodation Types",
            url: "/stays/accommodation-types",
          },
          {
            title: "Room Types",
            url: "/stays/room-types",
          },
        ],
      },
      {
        title: "Trips",
        url: "/trips",
        icon: Icons.HomeIcon,
        items: [
          {
            title: "All Trips",
            url: "/trips",
          },
          {
            title: "Create Trip",
            url: "/trips/create",
          },
          {
            title: "Trip Types",
            url: "/trips/trip-types",
          },
        ],
      },
      {
        title: "Customers",
        url: "/customers",
        icon: Icons.User,
        items: [
          {
            title: "All Customers",
            url: "/customers",
          },
          {
            title: "Create Customer",
            url: "/customers/create",
          },
        ],
      },
      {
        title: "Users",
        url: "/users",
        icon: Icons.FourCircle,
        items: [
          {
            title: "All Users",
            url: "/users",
          },
          {
            title: "Create User",
            url: "/users/create",
          },
        ],
      },
      {
        title: "Settings",
        url: "/settings",
        icon: Icons.FourCircle,
        items: [
          {
            title: "Currency",
            url: "/settings/currencies",
          },
        ],
      },
    ],
  },
];
